import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import commonSlice from "./commonSlice";
import memberSlice from "./memberSlice";
import roomSlice from "./roomSlice";

const store = configureStore({
  reducer: {
    common: commonSlice,
    member: memberSlice,
    room: roomSlice,
  },
  middleware: getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
// export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
